import { lazy, Suspense } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import PublicLayout from "./components/layout/PublicLayout";
import HomePage from "./pages/HomePage";
import HowItWorksPage from "./pages/HowItWorksPage";
import PricingPage from "./pages/PricingPage";
import FaqPage from "./pages/FaqPage";
import ContactPage from "./pages/ContactPage";
import LegalPage from "./pages/LegalPage";
import NotFoundPage from "./pages/NotFoundPage";
import { ROUTES } from "./config/routes";

const OwnerPortal = lazy(() => import("./portals/owner/OwnerPortal"));
const ScanPage = lazy(() => import("./portals/scan/ScanPage"));
const ReportPage = lazy(() => import("./portals/scan/ReportPage"));
const LocationPage = lazy(() => import("./portals/scan/LocationPage"));
const InternalPortal = lazy(() => import("./portals/internal/InternalPortal"));

function App() {
  return (
    <BrowserRouter>
      <Suspense fallback={<div className="min-h-screen bg-[#07080C]" />}>
        <Routes>
          <Route element={<PublicLayout />}>
            <Route path={ROUTES.HOME} element={<HomePage />} />
            <Route path={ROUTES.HOW_IT_WORKS} element={<HowItWorksPage />} />
            <Route path={ROUTES.PRICING} element={<PricingPage />} />
            <Route path={ROUTES.FAQ} element={<FaqPage />} />
            <Route path={ROUTES.CONTACT} element={<ContactPage />} />
            <Route path={ROUTES.PRIVACY} element={<LegalPage kind="privacy" />} />
            <Route path={ROUTES.TERMS} element={<LegalPage kind="terms" />} />
            <Route path="*" element={<NotFoundPage />} />
          </Route>
          <Route path={`${ROUTES.OWNER}/*`} element={<OwnerPortal />} />
          <Route path={ROUTES.SCAN} element={<ScanPage />} />
          <Route path={`${ROUTES.SCAN}/report/:reportId`} element={<ReportPage />} />
          <Route path="/loc/:token" element={<LocationPage />} />
          <Route path={`${ROUTES.INTERNAL}/*`} element={<InternalPortal />} />
        </Routes>
      </Suspense>
      <Toaster theme="dark" position="top-center" richColors />
    </BrowserRouter>
  );
}

export default App;
